import authRoutes from "@/router/routes/auth";
import Vertical from "@/layouts/vertical.vue";

export default [
    ...authRoutes,
  {
    path: "/",
    component: Vertical,
    authRequired: true,
    children: [
      {
        path: "",
        meta: {
          authRequired: true,
        },
        redirect: '/dashboard'
      },
      {
        path: "/dashboard",
        name: "dashboard",
        meta: {
          title: "Dashboard",
          authRequired: true,
          roles: ['superadmin']
        },
        component: () => import("../views/pages/dashboard/index.vue"),
      },
      {
        path: "/ad-banners",
        name: "ad-banners",
        meta: {
          title: "الإعلانات",
          roles: ['superadmin'],
          authRequired: true,
        },
        component: () => import("../views/pages/ad_banners/index.vue"),
      },
      {
        path: "/ad-banners/create",
        name: "ad-banners-create",
        meta: {
          title: "الإعلانات",
          roles: ['superadmin'],
          authRequired: true,
        },
        component: () => import("../views/pages/ad_banners/create.vue"),
      },
      {
        path: "/ad-banners/:id/edit",
        name: "ad-banners-edit",
        meta: {
          title: "الإعلانات",
          roles: ['superadmin'],
          authRequired: true,
        },
        component: () => import("../views/pages/ad_banners/create.vue"),
      },
      {
        path: "/services",
        name: "services",
        meta: {
          title: "الخدمات الأساسية",
          roles: ['superadmin'],
          authRequired: true,
        },
        component: () => import("../views/pages/services/basic/index.vue"),
      },
      {
        path: "/users/clients",
        name: "users-clients",
        meta: {
          title: "العملاء",
          roles: ['superadmin'],
          authRequired: true,
        },
        component: () => import("../views/pages/users/clients/index.vue"),
      },
      {
        path: "/users/clients/create",
        name: "users-clients-create",
        meta: {
          title: "العملاء",
          roles: ['superadmin'],
          authRequired: true,
        },
        component: () => import("../views/pages/users/clients/create.vue"),
      },
      {
        path: "/users/clients/:id/edit",
        name: "users-clients-edit",
        meta: {
          title: "العملاء",
          roles: ['superadmin'],
          authRequired: true,
        },
        component: () => import("../views/pages/users/clients/create.vue"),
      },
      {
        path: "/users/clients/:id",
        name: "client-details",
        meta: {
          title: "العملاء",
          roles: ['superadmin'],
          authRequired: true,
        },
        component: () => import("../views/pages/users/clients/details.vue"),

        children: [
          {
            path: "details",
            name: "client-info",
            meta: {
              title: "العملاء",
              roles: ['superadmin'],
              authRequired: true,
            },
            component: () => import("../views/pages/users/clients/components/info.vue")
          },
          {
            path: "appointments",
            name: "client-appointments",
            meta: {
              title: "العملاء",
              roles: ['superadmin'],
              authRequired: true
            },
            component: () => import("../views/pages/users/clients/components/appointmentsTable.vue")
          }
        ]
      },
      {
        path: "/users/vendors",
        name: "users-vendors",
        meta: {
          title: "مزودي الخدمات",
          roles: ['superadmin'],
          authRequired: true,
        },
        component: () => import("../views/pages/users/vendors/index.vue"),
      },
      {
        path: "/users/vendors/:id/edit",
        name: "vendor-edit",
        meta: {
          title: "مزودي الخدمات",
          roles: ['superadmin'],
          authRequired: true,
        },
        component: () => import("../views/pages/users/vendors/create.vue"),
      },
      {
        path: "/users/vendors/:id",
        name: "vendor-details",
        meta: {
          title: "مزودي الخدمات",
          roles: ['superadmin'],
          authRequired: true,
        },
        component: () => import("../views/pages/users/vendors/details.vue"),

        children: [
          {
            path: "details",
            name: "vendor-info",
            meta: {
              title: "مزودي الخدمات",
              roles: ['superadmin'],
              authRequired: true,
            },
            component: () => import("../views/pages/users/vendors/components/info.vue")
          },
          {
            path: "appointments",
            name: "vendor-appointments",
            meta: {
              title: "مزودي الخدمات",
              roles: ['superadmin'],
              authRequired: true
            },
            component: () => import("../views/pages/users/vendors/components/appointmentsTable.vue")
          },
          {
            path: "opening-times",
            name: "vendor-opening-times",
            meta: {
              title: "مزودي الخدمات",
              roles: ['superadmin'],
              authRequired: true
            },
            component: () => import("../views/pages/users/vendors/components/openingTimes.vue")
          },
        ]
      },
      {
        path: "/vendors-services",
        name: "vendors-services",
        meta: {
          title: "خدمات المزودين",
          roles: ['superadmin'],
          authRequired: true,
        },
        component: () => import("../views/pages/services/vendors/index.vue"),
      },
      {
        path: "/service-categories",
        name: "service-categories",
        meta: {
          title: "تصنيفات الخدمات",
          roles: ['superadmin'],
          authRequired: true,
        },
        component: () => import("../views/pages/categories/index.vue"),
      },
      {
        path: "/service-categories/:id/edit",
        name: "service-categories-edit",
        meta: {
          title: "تصنيفات الخدمات",
          roles: ['superadmin'],
          authRequired: true,
        },
        component: () => import("../views/pages/categories/create.vue"),
      },
      {
        path: "/service-categories/create",
        name: "service-categories-create",
        meta: {
          title: "تصنيفات الخدمات",
          roles: ['superadmin'],
          authRequired: true,
        },
        component: () => import("../views/pages/categories/create.vue"),
      },
      {
        path: "/services/create",
        name: "services-create",
        meta: {
          title: "الخدمات",
          authRequired: true,
          roles: ['superadmin']
        },
        component: () => import("../views/pages/services/basic/create.vue"),
      },
      {
        path: "/services/:id/edit",
        name: "services-edit",
        meta: {
          title: "الخدمات",
          authRequired: true,
          roles: ['superadmin']
        },
        component: () => import("../views/pages/services/basic/create.vue"),
      },
      {
        path: "/reports",
        name: "reports",
        meta: {
          title: "التقارير",
          authRequired: true,
          roles: ['superadmin']
        },
        component: () => import("../views/pages/stats/index.vue"),
      },
      {
        path: "/revenues",
        name: "revenues",
        meta: {
          title: "الإيرادات",
          authRequired: true,
          roles: ['superadmin']
        },
        component: () => import("../views/pages/revenues/index.vue"),
      },
      {
        path: "/chat",
        name: "chat",
        meta: {
          title: "المحادثات",
          authRequired: true,
          roles: ['superadmin']
        },
        component: () => import("../views/pages/chat/index.vue"),
      },
      {
        path: "/appointments/:id/details",
        name: "appointments-details",
        meta: {
          title: "تفاصيل الحجز",
          authRequired: true,
          roles: ['superadmin']
        },
        component: () => import("../views/pages/appointments/details.vue"),
      },
    ]
  },
  {
    path: '/auth/404',
    name: '404',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404')
  },
  {
    path: '/auth/500',
    name: '500',
    meta: {
      title: "Error 500", authRequired: true,
    },
    component: () => import('../views/auth/errors/500')
  },
  {
    path: '/auth/404-basic',
    name: '404-basic',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404-basic')
  },
];